export const TIME_FORMAT = "HH:mm:ss"
export const DATE_FORMAT_STRAPI = "YYYY-MM-DD"
